import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigService } from 'app/services/config.service';
import { DialogService } from '@progress/kendo-angular-dialog';
import { AuditModel, AuditSearchModel } from 'app/models/audit.model';

@Injectable()
export class AuditHistoryService {

  constructor(private api: HttpClient, private config: ConfigService,private dialogService: DialogService) { }

  public SearchAudit(model: AuditSearchModel): Observable<Array<AuditModel>> {
    return this.api.post<Array<AuditModel>>(this.config.getApiRoute('api/v3/common/audit'), model).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }





}
